import YouTubePlayer from 'youtube-player';

class ImageHeroCarouselSlide extends HTMLElement {
  constructor() {
    super();
  }

  /**
   * Finds the parent carousel's Swiper instance
   * @returns {Object|null} Swiper instance or null
   */
  getParentSwiper() {
    const carousel = this.closest('image-hero-carousel');
    return carousel?.swiper || null;
  }

  connectedCallback() {
    const youtubeButton = this.querySelector('.youtube-button');
    const context = this;

    if (youtubeButton) {
      youtubeButton.addEventListener('click', (e) => {
        e.preventDefault();
        // Find the youtube-embed element within this slide
        const youtubeEmbed = this.querySelector('youtube-embed');
        if (youtubeEmbed) {
          const modal = youtubeEmbed.querySelector('.youtube-modal');
          if (modal) {
            modal.classList.remove('hidden');
            // Call the injectYouTubePlayer method on the youtube-embed element
            youtubeEmbed.injectYouTubePlayer();

            // Pause carousel autoplay when YouTube video is opened
            const swiper = context.getParentSwiper();
            if (swiper && swiper.autoplay) {
              swiper.autoplay.stop();
            }

            // Setup listener to resume autoplay when modal is closed
            const handleModalClose = (event) => {
              if (!event.target.classList.contains('video-container')) {
                const swiper = context.getParentSwiper();
                if (swiper && swiper.autoplay) {
                  swiper.autoplay.start();
                }
                modal.removeEventListener('click', handleModalClose);
              }
            };
            modal.addEventListener('click', handleModalClose);
          }
        }
      });
    }
  }
}
customElements.define('image-hero-carousel-slide', ImageHeroCarouselSlide);
